import AssetList from './AssetList';

export default AssetList;
